import { Component, createRef } from 'react';
import Tooltip from '@mui/material/Tooltip'; // Använd MUI v5
import { Typography } from '@mui/material';

type OverflowTooltipProps = {
  children: string;
};

type OverflowTooltipState = {
  isOverflowed: boolean;
};

export class OverflowTooltip extends Component<OverflowTooltipProps, OverflowTooltipState> {
  textElement = createRef<HTMLDivElement>();

  constructor(props: OverflowTooltipProps) {
    super(props);
    this.state = {
      isOverflowed: false,
    };
  }

  componentDidMount() {
    this.checkOverflow();
    window.addEventListener('resize', this.checkOverflow);
  }

  componentDidUpdate(prevProps: OverflowTooltipProps) {
    const { children } = this.props;
    if (prevProps.children !== children) {
      this.checkOverflow();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkOverflow);
  }

  checkOverflow = () => {
    const el = this.textElement.current;
    if (el) {
      const isOverflowed = el.scrollWidth > el.clientWidth;
      this.setState({ isOverflowed });
    }
  };

  render() {
    const { isOverflowed } = this.state;
    const { children } = this.props;

    const content = (
      <Typography
        ref={this.textElement}
        variant='body2'
        color={(thm) => thm.palette.text.primary}
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'inline-block',
        }}
      >
        {children}
      </Typography>
    );

    return isOverflowed ? (
      <Tooltip placement='top' title={children} arrow>
        {content}
      </Tooltip>
    ) : (
      content
    );
  }
}
